import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { EventSalesStatsAddonsResponse, EventSalesStatsParams } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const createEventSalesStatsKey = (eventId: string | undefined, params: EventReportFilter | undefined) => {
  return [QUERY_KEYS.eventSalesStatsAddons, eventId, params];
};

const getEventSalesStatsAddons = async ({ eventId, params }: EventSalesStatsParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/addon-sales-stats?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventSalesStatsAddons = ({ eventId, params, options }: EventSalesStatsParams) => {
  return useGenericQuery<EventSalesStatsAddonsResponse, RequestError>(
    createEventSalesStatsKey(eventId, params),
    () => getEventSalesStatsAddons({ eventId, params }),
    {
      ...options,
    }
  );
};
